import styled from 'styled-components'
import { IconButton } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const Descriptions = styled.div<{ $invalid: boolean }>`
  font-size: 16px;
  color: ${({ $invalid }) =>
    $invalid ? myPalette.red.main : myPalette.dark.descriptionLabel};
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${myPalette.red.main};
`

export const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1/1;
  position: relative;
  border: 1px solid ${myPalette.blue.lightSteelBlue};
  border-radius: 6px;
  padding: 2px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
  }
`

export const DeleteButton = styled(IconButton)`
  position: absolute;
  top: 12px;
  right: 12px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`
